module.exports = {"name":"mokit","version":"3.1.3"}


//////////////////
// WEBPACK FOOTER
// ./~/_mokit@3.1.3@mokit/info.json
// module id = 2
// module chunks = 0